import React from "react";

// Actions
import ClientActions from "../../../actions/ClientActions";
import Dropdown from "../../_common/forms/Dropdown.react";

// Form items
import Input from "../../_common/forms/Input.react";
import Button from "../../_common/buttons/Button.react";

const zendeskOptions = [
	{
		text: "Assignee Name",
		value: "assignee name"
	},
	{
		text: "Group",
		value: "group"
	},
	{
		text: "Tag",
		value: "tag"
	},
	{
		text: "Status",
		value: "status"
	},
	{
		text: "Priority",
		value: "priority"
	},
	{
		text: "Type",
		value: "type"
	},
	{
		text: "Channel",
		value: "channel"
	},
	{
		text: "Subject",
		value: "subject"
	},
	{
		text: "Description",
		value: "description"
	}
];

const frontOptions = [
	{
		text: "Assignee Name",
		value: "assignee name"
	},
	{
		text: "Tag",
		value: "tag"
	},
	{
		text: "Status",
		value: "status"
	},
	{
		text: "Subject",
		value: "subject"
	},
	{
		text: "Type",
		value: "type"
	},
	{
		text: "Description",
		value: "description"
	},
	{
		text: "Mailbox address",
		value: "mailbox_address"
	},
	{
		text: "Inbox",
		value: "inbox"
	}
];

const zendeskStatusOptions = [
	{
		text: "New",
		value: 1
	},
	{
		text: "Open",
		value: 2
	},
	{
		text: "Pending",
		value: 3
	},
	{
		text: "On hold",
		value: 4
	},
	{
		text: "Solved",
		value: 5
	},
	{
		text: "Closed",
		value: 6
	}
];

const frontStatusOptions = [
	{
		text: "New",
		value: 1
	},
	{
		text: "Open",
		value: 2
	},
	{
		text: "Archived",
		value: 5
	},
	{
		text: "Deleted",
		value: 7
	}
];

class FilterRow extends React.Component {
	constructor(props) {
		super(props);
		this._updateFn = this._updateFn.bind(this);
		this._onBlur = this._onBlur.bind(this);
		this._onRemoveRule = this._onRemoveRule.bind(this);

		this.state = {
			type: this.props.item.type || "",
			state: this.props.item.state || "",
			value: this.props.item.value || "",
			workflow: this.props.item.workflow || "",
			sla: this.props.item.sla || ""
		};
	}

	_updateFn(field, location, value) {
		this.setState({ [field]: value });
	}

	_onBlur(field, location, value) {
		if (field === "type") {
			var defaultValue = "";
			if (value === "status" || value === "priority") {
				defaultValue = 1;
			}

			this.setState({ [field]: value, state: "is", value: defaultValue });

			ClientActions.setField(field, location, value, false);
			ClientActions.setField("state", location, "is", false);
			ClientActions.setField("value", location, defaultValue, true);
		} else {
			this.setState({ [field]: value });
			ClientActions.setField(field, location, value, true);
		}
	}

	_onRemoveRule() {
		if (this.props.totalRules === 1) {
			ClientActions.remove(this.props.location);
		} else {
			ClientActions.remove(this.props.location.concat(this.props.item.id));
		}
	}

	render() {
		const primaryStyle = {
			width: "100%",
			display: "inline-block",
			padding: "8px 0px"
		};

		const typeStyle = {
			width: "200px",
			marginBottom: "0px",
			marginRight: "16px"
		};

		const leftColumnStyle = {
			display: "inline-block",
			width: "calc(100% - 70px)",
			verticalAlign: "middle"
		};

		const closeIconStyle = {
			marginLeft: "16px",
			display: "inline-block",
			verticalAlign: "middle",
			cursor: "pointer"
		};

		// Figures out state options
		var stateOptions = [];
		var valueOptions = [];

		if (["mailbox_address", "assignee name", "group", "tag", "inbox"].indexOf(this.state.type) > -1) {
			stateOptions = [
				{
					text: "Is",
					value: "is"
				},
				{
					text: "Is not",
					value: "is not"
				},
				{
					text: "Contains",
					value: "contains"
				},
				{
					text: "Does not contain",
					value: "does not contain"
				}
			];
		} else if (this.state.type === "status") {
			stateOptions = [
				{
					text: "Is",
					value: "is"
				},
				{
					text: "Is not",
					value: "is not"
				},
				{
					text: "Less than",
					value: "less than"
				},
				{
					text: "Greater than",
					value: "greater than"
				}
			];

			valueOptions = this.props.type === "zendesk" ? zendeskStatusOptions : frontStatusOptions;
		} else if (this.state.type === "priority") {
			stateOptions = [
				{
					text: "Is",
					value: "is"
				},
				{
					text: "Is not",
					value: "is not"
				},
				{
					text: "Less than",
					value: "less than"
				},
				{
					text: "Greater than",
					value: "greater than"
				}
			];

			valueOptions = [
				{
					text: "Low",
					value: 1
				},
				{
					text: "Normal",
					value: 2
				},
				{
					text: "High",
					value: 3
				},
				{
					text: "Urgent",
					value: 4
				}
			];
		} else if (["subject", "description", "type"].indexOf(this.state.type) > -1) {
			stateOptions = [
				{
					text: "Is",
					value: "is"
				},
				{
					text: "Is not",
					value: "is not"
				},
				{
					text: "Contains",
					value: "contains"
				},
				{
					text: "Does not contain",
					value: "does not contain"
				}
			];
		} else if (this.state.type === "channel") {
			stateOptions = [
				{
					text: "Is",
					value: "is"
				},
				{
					text: "Is not",
					value: "is not"
				}
			];

			valueOptions = [
				{
					text: "Web form",
					value: "web"
				},
				{
					text: "Email",
					value: "email"
				},
				{
					text: "Chat",
					value: "chat"
				},
				{
					text: "Twitter",
					value: "twitter"
				},
				{
					text: "Twitter DM",
					value: "twitter_dm"
				},
				{
					text: "Twitter like",
					value: "twitter_favorite"
				},
				{
					text: "Voicemail",
					value: "voicemail"
				},
				{
					text: "Phone call (incoming)",
					value: "phone_call_inbound"
				},
				{
					text: "Phone call (outbound)",
					value: "phone_call_outbound"
				},
				{
					text: "CTI* voicemail",
					value: "api_voicemail"
				},
				{
					text: "CTI phone call (inbound)",
					value: "api_phone_call_inbound"
				},
				{
					text: "CTI phone call (outbound)",
					value: "api_phone_call_outbound"
				},
				{
					text: "SMS",
					value: "sms"
				},
				{
					text: "Get Satisfaction",
					value: "get_satisfaction"
				},
				{
					text: "Web Widget",
					value: "web_widget"
				},
				{
					text: "Mobile SDK",
					value: "mobile_sdk"
				},
				{
					text: "Mobile",
					value: "mobile"
				},
				{
					text: "Help Center post",
					value: "helpcenter"
				},
				{
					text: "Web service (API)",
					value: "web_service"
				},
				{
					text: "Trigger, automation",
					value: "rule"
				},
				{
					text: "Closed ticket",
					value: "closed_ticket"
				},
				{
					text: "Ticket sharing",
					value: "ticket_sharing"
				},
				{
					text: "Facebook post",
					value: "facebook_post"
				},
				{
					text: "Facebook private message",
					value: "facebook_message"
				},
				{
					text: "Satisfaction prediction",
					value: "satisfaction_prediction"
				},
				{
					text: "Channel framework",
					value: "any_channel"
				}
			];
		}

		var location = this.props.location.concat(this.props.item.id);

		return (
			<div style={primaryStyle}>
				<div style={leftColumnStyle}>
					<Dropdown
						id={"filter-type-" + this.props.parentIndex + "-" + this.props.index}
						style={typeStyle}
						value={this.state.type}
						field="type"
						location={location}
						label="Field"
						items={this.props.type === "zendesk" ? zendeskOptions : frontOptions}
						updateFn={this._onBlur}
						searchable={true}
						noHelp={true}
					/>
					{stateOptions.length > 0 ? (
						<Dropdown
							id={"filter-state-" + this.props.parentIndex + "-" + this.props.index}
							style={typeStyle}
							value={this.state.state}
							field="state"
							location={location}
							label="State"
							items={stateOptions}
							updateFn={this._onBlur}
							searchable={true}
							noHelp={true}
						/>
					) : (
						""
					)}
					{valueOptions.length > 0 ? (
						<Dropdown
							id={"filter-value-" + this.props.parentIndex + "-" + this.props.index}
							style={typeStyle}
							value={this.state.value}
							field="value"
							location={location}
							label="Value"
							items={valueOptions}
							updateFn={this._onBlur}
							searchable={true}
							noHelp={true}
						/>
					) : (
						<Input
							id={"filter-value-" + this.props.parentIndex + "-" + this.props.index}
							style={typeStyle}
							value={this.state.value}
							field="value"
							location={location}
							label="Value"
							updateFn={this._updateFn}
							onBlur={this._onBlur}
							noHelp={true}
						/>
					)}
					{this.props.workflows !== undefined && this.props.index === 0 ? (
						<Dropdown
							id={"filter-autoworkflows-workflow-" + this.props.parentIndex + "-" + this.props.index}
							style={typeStyle}
							value={this.state.workflow || ""}
							field="workflow"
							location={location}
							label="Workflow"
							items={this.props.workflows}
							updateFn={this._onBlur}
							searchable={true}
							noHelp={true}
						/>
					) : (
						""
					)}
					{this.props.sla && this.props.index === 0 ? (
						<Input
							id={"filter-sla-" + this.props.parentIndex + "-" + this.props.index}
							style={typeStyle}
							value={this.state.sla || ""}
							field="sla"
							location={location}
							label="SLA Hours"
							updateFn={this._updateFn}
							onBlur={this._onBlur}
							type="number"
							noHelp={true}
						/>
					) : (
						""
					)}
				</div>
				<i style={closeIconStyle} className="material-icons" onClick={this._onRemoveRule}>
					close
				</i>
			</div>
		);
	}
}

class Filter extends React.Component {
	constructor(props) {
		super(props);
		this._onAddNewOrder = this._onAddNewOrder.bind(this);
	}

	_onAddNewOrder() {
		ClientActions.add("rules", this.props.location.concat(this.props.item.id), {
			type: "assignee name",
			state: "is",
			value: "Hioperator"
		});
	}

	render() {
		const primaryStyle = {
			borderTop: this.props.index === 0 ? "1px solid lightgrey" : "",
			borderBottom: "1px solid lightgrey",
			display: "inline-block",
			width: "100%"
		};

		const filterButtonContainerStyle = {
			margin: "16px 0px",
			width: "100%",
			textAlign: "left"
		};

		const labelStyle = {
			width: "100%",
			textAlign: "center",
			fontSize: "20px",
			margin: "8px 0px",
			fontWeight: "700"
		};

		var rows = Array.isArray(this.props.item.rules) && this.props.item.rules.length > 0 ? this.props.item.rules : [];
		return (
			<div style={primaryStyle}>
				{rows.map((item, index, arr) => (
					<FilterRow
						key={this.props.item.id + "-" + index}
						item={item}
						index={index}
						parentIndex={this.props.index}
						location={this.props.location.concat(this.props.item.id)}
						totalRules={arr.length}
						workflows={this.props.workflows}
						sla={this.props.sla}
						type={this.props.type}
					/>
				))}
				<div style={filterButtonContainerStyle}>
					<Button text="Add AND Clause" onClick={this._onAddNewOrder} />
				</div>
				{!this.props.last ? <div style={labelStyle}>OR</div> : ""}
			</div>
		);
	}
}

export default Filter;
